const DOCUMENT = 'SESSION_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_ORIENTATION_DETAILS_SUCCESS: DOCUMENT + 'LOAD_ORIENTATION_DETAILS_SUCCESS',

  loadSession: data => {
    return {
      type: actions.LOAD_REQUEST,
      payload: data,
    };
  },

  loadSessionSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadOrintationDetailsSuccess: data => ({
    type: actions.LOAD_ORIENTATION_DETAILS_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
